import {
    ITextFieldStyles,
    IStackStyles,
    ICheckboxStyles,
    ISearchBoxProps,
    ISliderStyles,
    IDropdownStyles,
    IIconProps,
    IStyle,
    mergeStyleSets,
    IDocumentCardStyles,
    IDetailsColumnStyles,
    IDocumentCardPreviewStyles,
    IPivotStyles,
    IToggleProps,
    IToggleStyles,
    IDetailsRowStyles,
    IDetailsListStyles,
    IDetailsHeaderStyles,
    IButtonStyles,
    ITooltipHostStyles,
    ICalloutContentStyles,
    IContextualMenuStyles,
    ITooltipStyles,
    IPanelStyles,
    ITextStyles,
    IHoverCardStyles,
    IExpandingCardStyles,
    IDetailsRowProps,
    IScrollablePaneStyles,
    IModalStyles,
    IDetailsHeaderProps,
    DetailsHeader,
    IDocumentCardTitleStyles,
    IBasePickerStyles,
    ISearchBoxStyles
} from "@fluentui/react";

import { createTheme } from "@fluentui/react";
import { keyframes } from "@fluentui/react";

const borderColorOne = "#b9daea";
const colorOne = "#56778c";

export const impWordsTagInputStyles: Partial<IBasePickerStyles> = {

    text:{
        borderRadius: "6px",
        selectors: {
            "::after": {
                borderRadius: "6px ",
            },
            ":hover": {
                borderRadius: "6px ",
            },
            ":active": {
                borderRadius: "6px ",
            },
            ":focus": {
                borderRadius: "6px ",
            }
        }
    }
}


export const campaignInputVoiceDropdownStyles: Partial<IDropdownStyles> = {
    root: {
        minWidth: 120,
        maxWidth: 180,
        borderRadius: 4,
        fontFamily: "Raleway, Urbanist, Roboto, sans-serif",
        color: "#484848  !important",
        borderColor: "rgba(82, 82, 82, 0.685) !important",
        background: "rgba(255,255,255,0.12) !important",
        border: "1px solid rgba(110, 110, 110, 0.848) !important",
        selectors: {
            ":focus::after": { borderWidth:"1px !important", borderRadius: 6, borderColor: "#ffffff !important" },
            ":active::after": { borderWidth:"1px !important", borderRadius: 6, borderColor: "#ffffff !important" },
            ":hover::after": { borderWidth:"1px !important", borderRadius: 6, borderColor: "#ffffff !important" },
            ":focus:before": { borderWidth:"1px !important", borderRadius: 6, borderColor: "#ffffff !important" },
            ":active:before": { borderWidth:"1px !important", borderRadius: 6, borderColor: "#ffffff !important" },
            ":hover:before": { borderWidth:"1px !important", borderRadius: 6, borderColor: "#ffffff !important" },
            ":active": { borderWidth:"1px !important", borderRadius: 6, borderColor: "#ffffff !important" },
            ":focus": { borderWidth:"1px !important", borderRadius: 6, borderColor: "#ffffff !important" },
            ".ms-Dropdown-title": { color: "#5c5c5c" },



        }
     },
     caretDownWrapper:{
        borderRadius: 4,
        borderColor: "rgba(82, 82, 82, 0.685) !important",
        selectors: {
            ":focus::after": { borderWidth:"1px !important", borderRadius: 6, borderColor: "#ffffff !important" },
            ":active::after": { borderWidth:"1px !important", borderRadius: 6, borderColor: "#ffffff !important" },
            ":hover::after": { borderWidth:"1px !important", borderRadius: 6, borderColor: "#ffffff !important" },
            ":focus:before": { borderWidth:"1px !important", borderRadius: 6, borderColor: "#ffffff !important" },
            ":active:before": { borderWidth:"1px !important", borderRadius: 6, borderColor: "#ffffff !important" },
            ":hover:before": { borderWidth:"1px !important", borderRadius: 6, borderColor: "#ffffff !important" },
            ":active": { borderWidth:"1px !important", borderRadius: 6, borderColor: "#ffffff !important" },
            ":focus": { borderWidth:"1px !important", borderRadius: 6, borderColor: "#ffffff !important" },
            ".ms-Dropdown-title": { color: "#5c5c5c" },

        }

     },
     title: {
        fontFamily: "Raleway, Urbanist, Roboto, sans-serif", fontSize: 11, height: 30, lineHeight: "28px",
        background: "rgba(255,255,255,0.08)", borderColor: "rgba(255,255,255,0.15) !important",

        color: "#484848",
        selectors: {
            ":focus::after": { borderWidth:"1px !important", borderRadius: 6, borderColor: "rgba(82, 82, 82, 0) !important", transition:"height 0.3s ease" },
            ":active::after": { borderWidth:"1px !important", borderRadius: 6, borderColor: "rgba(82, 82, 82, 0) !important", transition:"height 0.3s ease" },
            ":hover::after": { borderWidth:"1px !important", borderRadius: 6, borderColor: "rgba(82, 82, 82, 0) !important", transition:"height 0.3s ease" },
            ":focus": { borderWidth:"1px !important", borderRadius: 6, borderColor: "rgba(82, 82, 82, 0) !important", transition:"height 0.3s ease" },
            ".ms-Dropdown-title": { color: "#5c5c5c" },

            ":active": { borderWidth:"1px !important", borderRadius: 6, borderColor: "rgba(82, 82, 82, 0) !important", transition:"height 0.3s ease" },
            ":hover": { borderWidth:"1px !important", borderRadius: 6, borderColor: "rgba(255,255,255,0.15) !important", transition:"height 0.3s ease" },


        }
    },
    dropdown: {
        borderRadius: 4,
        borderColor: "rgba(82, 82, 82, 0.685) !important",
        selectors: {

        }
    },
    dropdownItem: { fontFamily: "Raleway, Urbanist, Roboto, sans-serif", fontSize: 12, height: 30 },
    dropdownItemSelected: { fontFamily: "Raleway, Urbanist, Roboto, sans-serif", fontSize: 12, height: 30, fontWeight: 600 },
    caretDown: { color: "#5b5b5b", fontSize: 10 }
}

export const textFieldStyles: Partial<ITextFieldStyles> = {
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist"
            }
        }
    },
    root: {
        borderRadius: "5px"
    },
    fieldGroup: {
        width: "90vw",
        maxWidth: "800px",
        borderRadius: "5px",
        selectors: {
            "::after": {
                borderRadius: "5px ",
                border: "2px solid #404040"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const txtSpaceGenEditStyles: Partial<ITextFieldStyles> = {
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist"
            }
        }
    },
    root: {
        width: "auto",
        minWidth: "300px",
        borderRadius: "5px"
    },
    fieldGroup: {
        borderRadius: "5px",
        selectors: {
            "::after": {
                borderRadius: "5px ",
                border: "2px solid #404040"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const textFieldModalContentTypeCreateStyles: Partial<ITextFieldStyles> = {
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist"
            }
        }
    },
    root: {
        borderRadius: "5px"
    },
    fieldGroup: {
        width: "300px",
        maxWidth: "90vw",
        borderRadius: "5px",
        selectors: {
            "::after": {
                borderRadius: "5px ",
                border: "2px solid #404040"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const textFieldModalSupportStyles: Partial<ITextFieldStyles> = {
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist"
            }
        }
    },
    root: {
        borderRadius: "5px"
    },
    fieldGroup: {
        width: "300px",
        maxWidth: "90vw",
        borderRadius: "5px",
        selectors: {
            "::after": {
                borderRadius: "5px ",
                border: "2px solid #404040"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const newAssistantModalStyles: Partial<IModalStyles> = {
    scrollableContent: {
        width: "100%",
        minHeight: "200px",
        display: "flex",
        flexDirection: "column",
    },
    main: {
        minHeight: "200px"
    },
    root:  {

        backgroundColor: "#ffffff00",
    }
}

export const modalAIAnalysisStyles: Partial<IModalStyles> = {
    scrollableContent: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        overflowX: "hidden",
    },
    main: {
        height: "auto"
    },
    root:  {

        backgroundColor: "#ffffff00",
    }
}

export const textSPOFieldStyles: Partial<ITextFieldStyles> = {
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist"
            }
        }
    },
    root: {
        borderRadius: "5px"
    },
    fieldGroup: {
        maxWidth: "880px",
        borderRadius: "5px",
        selectors: {
            "::after": {
                borderRadius: "5px ",
                border: "2px solid #404040"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const textFieldSiteMapStyles: Partial<ITextFieldStyles> = {
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist"
            }
        }
    },
    root: {
        borderRadius: "5px"
    },
    fieldGroup: {
        width: "90vw",
        maxWidth: "300px",
        marginBottom: "10px",
        borderRadius: "5px",
        selectors: {
            "::after": {
                borderRadius: "5px ",
                border: "2px solid #404040"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const textFieldStylesDocExtractImportScheme: Partial<ITextFieldStyles> = {
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist"
            }
        }
    },
    root: {
        borderRadius: "5px"
    },
    fieldGroup: {
        borderRadius: "5px",
        selectors: {
            "::after": {
                borderRadius: "5px ",
                border: "2px solid #404040"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const textFieldStylesPersonLabelRecognizer: Partial<ITextFieldStyles> = {
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist"
            }
        }
    },
    root: {
        borderRadius: "5px"
    },
    fieldGroup: {
        borderRadius: "5px",
        maxWidth: 80,
        width: 80,
        marginRight: 8,
        selectors: {
            "::after": {
                borderRadius: "5px ",
                border: "2px solid #404040"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const titleTextFieldStylesPersonLabelRecognizer: Partial<ITextFieldStyles> = {
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Roboto !important",
                fontSize: "27px !important"
            }
        }
    },
    root: {
        borderRadius: "5px",
        fontFamily: "Roboto !important",
        fontSize: "27px !important"
    },
    fieldGroup: {
        borderRadius: "5px",
        fontFamily: "Roboto !important",
        fontSize: "47px !important",
        marginRight: 8,
        selectors: {
            "::after": {
                borderRadius: "5px !important",
                border: "2px solid #404040"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontFamily: "Roboto !important",
                fontSize: "27px !important"
            }
        }
    }
};

export const textFieldStylesMultiline: Partial<ITextFieldStyles> = {
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist"
            }
        }
    },
    root: {
        borderRadius: "8px"
    },
    fieldGroup: {
        width: "90vw",
        maxWidth: "800px",
        height: 200,
        borderRadius: "8px",
        selectors: {
            "::after": {
                borderRadius: "8px ",
                border: "2px solid #333"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const textFieldStylesMultilineSpaceEdit: Partial<ITextFieldStyles> = {
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist"
            }
        }
    },
    root: {
        borderRadius: "8px"
    },
    fieldGroup: {
        width: "100%",

        height: 200,
        borderRadius: "8px",
        selectors: {
            "::after": {
                borderRadius: "8px ",
                border: "2px solid #333"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const textFieldMutlilineGreetingStyles: Partial<ITextFieldStyles> = {
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist"
            }
        }
    },
    root: {
        borderRadius: "8px"
    },
    fieldGroup: {
        width: "100%",

        borderRadius: "8px",
        selectors: {
            "::after": {
                borderRadius: "8px ",
                border: "2px solid #333"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const textFieldStylesMultiAIAnalyseOpt: Partial<ITextFieldStyles> = {
    wrapper: {

        selectors: {
            label: {
                fontFamily: "Urbanist"
            }
        }
    },
    field: {
        overflowY: "scroll",
        overflowX: "hidden",
        maxHeight: "50vh",
    },
    root: {
        borderRadius: "8px",
        padding: "8px",
        fontFamily: "Urbanist",
        fontSize: "14px",
        display: "block",
        minWidth: "100%",


    },
    fieldGroup: {

        margin: "0 auto", // Center the element horizontally
        borderRadius: "4px",
        border: "1px solid #999999;",

        selectors: {
            "::after": {
                borderRadius: "8px ",
                border: "0px solid #d1d1d1;",
                boxShadow: "0 4px 10px rgba(131, 131, 131, 0.3)"
            },
            ":hover": {
                boxShadow: "0 4px 10px rgba(131, 131, 131, 0.3)"
            },
            ":focus": {
                border: "0px solid #d1d1d1;"
            },
            ":active": {
                border: "1px solid #9b9b9b;"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const textFieldStylesScenarioMultilineV2: Partial<ITextFieldStyles> = {
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist"
            }
        }
    },
    root: {
        borderRadius: "8px",overflowY: "calc(100% - 5px)"
    },
    fieldGroup: {
        width: "100%",
        maxWidth: "800px",
        maxHeight: "1000px",
        border: "1px solid #cdcdcd !important",
        borderRadius: "8px",
        overflowY: "scroll",
        overflowX: "hidden",

        selectors: {
            "::after": {
                border: "0px solid #cdcdcd !important",
            }
            , ":hover": {
                border: "1px solid #cdcdcd !important",
                boxShadow: "0 8px 10px rgba(131, 131, 131, 0.3)"
            },

            "::before": {
                borderRadius: "8px ",

                border: "1px solid #cdcdcd !important"
            },

            ":focus": {
                borderRadius: "4px ",
                border: "1px solid #cdcdcd !important"
            },
            ":active": {
                borderRadius: "8px ",
                border: "1px solid #cdcdcd !important"
            },
            ":focus-within": {
                borderRadius: "8px ",
                border: "1px solid #cdcdcd !important"
            },
            ":focus-visible": {
                borderRadius: "8px ",
                border: "1px solid #cdcdcd !important"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const textFieldStylesScenarios: Partial<ITextFieldStyles> = {
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist"
            }
        }
    },
    root: {
        borderRadius: "8px",
        borderColor: "#e1e1e1"
    },
    fieldGroup: {
        width: "100%",
        borderColor: "#e1e1e1",
        borderRadius: "8px",
        transition: "border 0.2s ease, box-shadow 0.1s ease",
        selectors: {
            "::after": {
                borderRadius: "8px",
                border: "1px solid #2F4858",
                boxShadow: "0 4px 10px rgba(131, 131, 131, 0.3)"
            },
            ":hover": {
                border: "1px solid #b6b6b6",
                boxShadow: "0 4px 10px rgba(131, 131, 131, 0.3)"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const textFieldTitleStylesSingleScenarios: Partial<ITextFieldStyles> = {
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist"
            }
        }
    },
    root: {
        borderRadius: "5px",
        borderColor: "#e1e1e1"
    },
    fieldGroup: {
        borderRadius: "5px",
        width: "100%",
        minWidth: "300px",
        borderColor: "#e1e1e1",
        marginRight: 8,
        transition: "border 0.2s ease, box-shadow 0.1s ease",
        selectors: {
            "::after": {
                borderRadius: "8px",
                border: "1px solid #2F4858",
                boxShadow: "0 4px 10px rgba(131, 131, 131, 0.3)"
            },
            ":hover": {
                border: "1px solid #b6b6b6",
                boxShadow: "0 4px 10px rgba(131, 131, 131, 0.3)"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const textFieldStylesSingleScenarios: Partial<ITextFieldStyles> = {
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist"
            }
        }
    },
    root: {
        borderRadius: "5px",
        borderColor: "#e1e1e1"
    },
    fieldGroup: {
        borderRadius: "5px",
        width: "100%",
        borderColor: "#e1e1e1",
        marginRight: 8,
        transition: "border 0.2s ease, box-shadow 0.1s ease",
        selectors: {
            "::after": {
                borderRadius: "8px",
                border: "1px solid #2F4858",
                boxShadow: "0 4px 10px rgba(131, 131, 131, 0.3)"
            },
            ":hover": {
                border: "1px solid #b6b6b6",
                boxShadow: "0 4px 10px rgba(131, 131, 131, 0.3)"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const textFieldStylesMultilineRecognizer: Partial<ITextFieldStyles> = {
    wrapper: {
        width: "100%",
        maxWidth: "100%",
        marginLeft: "-5px",
        marginBottom: "-5px"
    },
    root: {
        borderRadius: "8px",
        width: "100%"
    },
    field: {
        font: "normal normal 13px/20px Urbanist,Roboto !important",
        margin: "0px",
        paddingTop: "9px",
        paddingLeft: "7px",
        paddingRight: "8px",
        width: "100%"
    },
    fieldGroup: {
        borderRadius: "8px",
        margin: "0",
        padding: "0",
        selectors: {
            "::after": {
                borderRadius: "8px ",
                border: "2px solid #333"
            }
        }
    }
};

export const textFieldInvoiceFieldChooser: Partial<ITextFieldStyles> = {
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist, Roboto"
            }
        }
    },
    field: { lineHeight: "18px", padding: "2px 4px", fontFamily: "Urbanist, Roboto", fontSize: "12px" },
    root: {
        borderRadius: "8px",
        border: "1px solid #cedae5"
    },
    fieldGroup: {
        minHeight: "25px",

        borderRadius: "8px",
        border: "1px solid #cedae5",
        selectors: {
            border: "1px solid #cedae5",
            "::after": {
                borderRadius: "8px ",
                border: "1px solid #cedae5"
            },
            "::hover": {
                borderRadius: "8px ",
                border: "1px solid #cedae5"
            },
            "::active": {
                borderRadius: "8px ",
                border: "1px solid #cedae5"
            },
            "::focus": {
                borderRadius: "8px ",
                border: "1px solid #cedae5"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const textFieldStylesDocExtr: Partial<ITextFieldStyles> = {
    field: {
        fontSize: "12px",
        fontFamily: "Urbanist, Roboto"
    },
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist",
                fontSize: "10px"
            }
        }
    },
    root: {
        margin: "-5px",
        borderRadius: "5px",
        fontSize: "12px"
    },
    fieldGroup: {
        borderRadius: "5px",
        fontSize: "12px",

        selectors: {
            "::after": {
                borderRadius: "5px ",
                border: "2px solid #404040"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "12px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const textFieldStylesTagInput: Partial<ITextFieldStyles> = {
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist"
            }
        }
    },
    root: {
        borderRadius: "5px"
    },
    fieldGroup: {
        maxWidth: "100%",
        borderRadius: "5px",
        selectors: {
            "::after": {
                borderRadius: "5px ",
                border: "2px solid #404040"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const searchTextFieldInCalloutStyle: Partial<ITextFieldStyles> = {
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist"
            }
        }
    },
    root: {
        borderRadius: "4px"
    },
    fieldGroup: {
        maxWidth: "800px",
        borderRadius: "4px",
        marginLeft: "4px",
        marginRight: "4px",
        marginTop: "4px",
        marginBottom: "4px",
        border: "1px solid #cdcdcd",
        selectors: {
            "::after": {
                borderRadius: "4px ",
                border: "1px solid #cdcdcd"
            },
            "::before": {
                borderRadius: "4px ",
                border: "1px solid #cdcdcd"
            },
            ":hover": {
                borderRadius: "4px ",
                border: "1px solid #cdcdcd"
            },
            ":focus": {
                borderRadius: "4px ",
                border: "1px solid #cdcdcd"
            },
            ":active": {
                borderRadius: "4px ",
                border: "1px solid #cdcdcd"
            },
            ":focus-within": {
                borderRadius: "4px ",
                border: "1px solid #cdcdcd"
            },
            ":focus-visible": {
                borderRadius: "4px ",
                border: "1px solid #cdcdcd"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const textFieldStylesMultilineDocExtr: Partial<ITextFieldStyles> = {
    field: {
        height: 31,
        fontSize: "12px",
        fontFamily: "Urbanist, Roboto"
    },
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist"
            }
        }
    },
    root: {
        marginTop: "-5px",
        borderRadius: "5px"
    },
    fieldGroup: {
        width: "calc(100% )",
        borderRadius: "5px",
        selectors: {
            "::after": {
                borderRadius: "5px ",
                border: "2px solid #333"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const textFieldStylesFeedbackDirect: Partial<ITextFieldStyles> = {
    field: {
        fontSize: "12px",
        fontFamily: "Urbanist, Roboto"
    },
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist"
            }
        }
    },
    root: {
        marginTop: "-5px",
        borderRadius: "5px"
    },
    fieldGroup: {
        width: "calc(100% )",
        borderRadius: "5px",
        selectors: {
            "::after": {
                borderRadius: "5px ",
                border: "2px solid #333"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const textFieldStylesMultilineShortDocExtr: Partial<ITextFieldStyles> = {
    field: {
        minHeight: "50px !important",
        fontSize: "12px",
        fontFamily: "Urbanist, Roboto"
    },
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist"
            }
        }
    },
    root: {
        marginTop: "-5px",
        borderRadius: "5px",
        minHeight: "50px !important"
    },
    fieldGroup: {
        width: "calc(100% )",

        minHeight: "50px !important",
        borderRadius: "5px",
        selectors: {
            "::after": {
                borderRadius: "5px ",
                border: "2px solid #333"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const textFieldStylesMultilineDocExtrDPA: Partial<ITextFieldStyles> = {
    field: {
        height: 30,
        fontSize: "12px",
        fontFamily: "Urbanist, Roboto"
    },
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist"
            }
        }
    },
    root: {
        borderRadius: "5px"
    },
    fieldGroup: {
        minHeight: 67,


        borderRadius: "5px",
        selectors: {
            "::after": {
                borderRadius: "5px ",
                border: "1px solid #333"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const textFieldStylesMultilineSiteMap: Partial<ITextFieldStyles> = {
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist"
            }
        }
    },
    root: {
        marginTop: "-5px",
        borderRadius: "8px",
        marginBotom: "5px"
    },
    fieldGroup: {
        height: 72,
        width: "100%",
        minWidth: "300px",
        maxWidth: "500px",
        borderRadius: "8px",
        marginBotom: "5px",
        selectors: {
            "::after": {
                borderRadius: "8px ",
                border: "2px solid #333"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const textFieldNewAssistantStyles: Partial<ITextFieldStyles> = {
    root: {
        borderRadius: "5px"
    },
    fieldGroup: {
        borderRadius: "5px",
        selectors: {
            "::after": {
                borderRadius: "5px "
                //border: "2px solid #404040"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const textFieldInvConfInstrStyles: Partial<ITextFieldStyles> = {
    root: {
        borderRadius: "5px",
        marginRight: "5px"
    },
    fieldGroup: {

        borderRadius: "5px",
        selectors: {
            "::after": {
                borderRadius: "5px "
                //border: "2px solid #404040"
            }
        }
    },
    field: {
        maxHeight: "70vh",
        overflowY: "auto"
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        },

    }
};

export const textChatFileFilterStyles: Partial<ITextStyles> = {
    root: {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        display: "block",
        width: "100%",
        maxWidth: "350px",
        padding: "1px 4px 1px 7px",
        background: "#eee",
        borderRadius: 6,
        cursor: "pointer",
        justifyContent: "center",
        font: "normal normal 400 10px/14px Urbanist, roboto, sans-serif"
    }
};

export const listContextMenuStyles: Partial<IContextualMenuStyles> = {
    list: {
        borderRadius: "5px !important",
    },
    root: {
        borderRadius: "5px !important",
    },
    container: {
        borderRadius: "5px !important"
    },
    subComponentStyles: {
        callout: {
            root: {
                borderRadius: "5px !important"
            }
        },
        menuItem: {
            root: {
                fontFamily: "Urbanist, Roboto !important",
            }
        }
    }
};

export const recoFieldSelectCheckBoxStyles: Partial<ICheckboxStyles> = {
    text: {
        fontFamily: "Raleway, Urbanist, Roboto, sans-serif",
        fontSize: "10px",
        marginTop: "-2px",
        marginLeft: "3px"
    },
    checkbox: {
        width: "14px",
        height: "14px",
        background: "white",
        border: "1px solid #747474",
        color: "white",
        borderColor: "#747474", // Border color when unchecked
        selectors: {
            ":after": {
                content: '""',
                borderColor: "#747474",
                background: "#747474",
                color: "#747474"
            },
            ":hover": {
                border: "3px solid #747474"
            },
            ":focus": {
                border: "3px solid #747474"
            },
            ":active": {
                border: "3px solid #747474"
            }
        }
    },
    label: {
        marginLeft: "5px",
        height: "14px"
    },
    checkmark: {
        color: "white", // Color of the checkmark
        background: "#b9b9b9",
        border: "3px solid #b9b9b9",
        selectors: {
            ":hover": {
                color: "white", // Hover checkmark color
                border: "3px solid white"
            }
        }
    },
    root: {
        fontFamily: "Urbanist",
        selectors: {
            ":hover .ms-Checkbox-checkbox": {
                background: "#5f5f5f",
                border: "3px solid #5f5f5f"
            },
            ":hover .ms-Checkbox-checkmark": {
                background: "#7e7e7e", // Hover checkmark color
                border: "1px solid #7e7e7e"
            },
            ".is-checked .ms-Checkbox-checkbox": {
                background: "#7e7e7e",
                border: "3px solid #7e7e7e"
            }
        },
        margin: "-8px 0px"
    }
};

export const ccaCheckBoxStyles: Partial<ICheckboxStyles> = {
    text: {
        fontFamily: "Urbanist",
        fontSize: "10px",
        marginTop: "-3px",
        marginLeft: "-2px"
    },
    checkbox: {
        width: "14px",
        height: "14px",
        background: "white",
        border: "1px solid #747474",
        color: "white",
        borderColor: "#747474", // Border color when unchecked
        selectors: {
            ":after": {
                content: '""',
                borderColor: "#747474",
                background: "#747474",
                color: "#747474"
            },
            ":hover": {
                border: "3px solid #747474"
            },
            ":focus": {
                border: "3px solid #747474"
            },
            ":active": {
                border: "3px solid #747474"
            }
        }
    },
    label: {
        width: "14px",
        height: "14px"
    },
    checkmark: {
        color: "white", // Color of the checkmark
        background: "#b9b9b9",
        border: "3px solid #b9b9b9",
        selectors: {
            ":hover": {
                color: "white", // Hover checkmark color
                border: "3px solid white"
            }
        }
    },
    root: {
        fontFamily: "Urbanist",
        selectors: {
            ":hover .ms-Checkbox-checkbox": {
                background: "#5f5f5f",
                border: "3px solid #5f5f5f"
            },
            ":hover .ms-Checkbox-checkmark": {
                background: "#7e7e7e", // Hover checkmark color
                border: "1px solid #7e7e7e"
            },
            ".is-checked .ms-Checkbox-checkbox": {
                background: "#7e7e7e",
                border: "3px solid #7e7e7e"
            }
        }
    }
};

export const fieldSelectStyles: Partial<ICheckboxStyles> = {
    text: {
        fontFamily: "Urbanist, Raleway, Roboto, sans-serif",
        fontSize: "13px",

    },
    checkbox: {
        width: "15px",
        height: "15px",
        background: "white",
        border: "1px solid #747474",
        color: "white",
        borderColor: "#2f485887", // Border color when unchecked
        selectors: {
            ":after": {
                content: '""',
                borderColor: "#747474",
                background: "#747474",
                color: "#747474"
            },
            ":hover": {
                border: "3px solid #747474"
            },
            ":focus": {
                border: "3px solid #747474"
            },
            ":active": {
                border: "3px solid #747474"
            }
        }
    },
    label: {
        fontFamily: "Urbanist, Raleway, Roboto, sans-serif",
        height: "16px"
    },
    checkmark: {
        color: "white", // Color of the checkmark
        background: "#b9b9b9",
        border: "3px solid #b9b9b9",
        selectors: {
            ":hover": {
                color: "white", // Hover checkmark color
                border: "3px solid white"
            }
        }
    },
    root: {
        fontFamily: "Urbanist",
        selectors: {
            ":hover .ms-Checkbox-checkbox": {
                background: "#7e7e7e",
                border: "2px solid #7e7e7e"
            },
            ":hover .ms-Checkbox-checkmark": {
                background: "#7e7e7e", // Hover checkmark color
                border: "1px solid #7e7e7e"
            },
            ".is-checked .ms-Checkbox-checkbox": {
                background: "#7e7e7e",
                border: "3px solid #7e7e7e"
            }
        }
    }
};

export const invCheckInvStyles: Partial<ICheckboxStyles> = {
    text: {
        fontSize: "10px",
        marginTop: "0px",
        marginLeft: "2px",
        justifyContent: "center",
        font: 'normal normal normal 12px/12px "Urbanist","Roboto"'
    },
    checkbox: {
        width: "14px",
        height: "14px",

    },
    label: {
        fontFamily: "Urbanist, Roboto",
        fontSize: "10px",
        width: "14px",
        height: "10px",
        justifyContent: "center",
        alignItems: "center"
    },
    checkmark: {
        selectors: {
            ":hover": {
                border: "3px solid white"
            }
        }
    },
    root: {
        fontFamily: "Urbanist",
        selectors: {
            ":hover .ms-Checkbox-checkbox": {

            },
            ":hover .ms-Checkbox-checkmark": {

            },
            ".is-checked .ms-Checkbox-checkbox": {
                background: "#7e7e7e",
                border: "3px solid #7e7e7e"

            }
        }
    }
};

export const ccaCheckBoxInvReqStyles: Partial<ICheckboxStyles> = {
    text: {
        fontSize: "10px",
        marginTop: "0px",
        marginLeft: "2px",
        justifyContent: "center",
        font: 'normal normal normal 12px/12px "Urbanist","Roboto"'
    },
    checkbox: {
        width: "14px",
        height: "14px",

    },
    label: {
        fontFamily: "Urbanist, Roboto",
        fontSize: "10px",
        width: "auto",
        height: "10px",
        justifyContent: "center",
        alignItems: "center"
    },
    checkmark: {
        selectors: {
            ":hover": {

            }
        }
    },
    root: {
        fontFamily: "Urbanist",
        marginLeft: "0px",
        selectors: {
            ":hover .ms-Checkbox-checkbox": {

            },
            ":hover .ms-Checkbox-checkmark": {

            },
            ".is-checked .ms-Checkbox-checkbox": {
                background: "#7e7e7e",
                border: "3px solid #7e7e7e"

            }
        }
    }
};

export const ccaToggleInvReqStyles: Partial<ICheckboxStyles> = {
    text: {
        fontSize: "10px",
        marginTop: "0px",
        marginLeft: "2px",
        justifyContent: "center",
        font: 'normal normal normal 12px/12px "Urbanist","Roboto"'
    },
    checkbox: {
        width: "14px",
        height: "14px",

    },
    label: {
        fontFamily: "Urbanist, Roboto",
        fontSize: "10px",
        width: "auto",
        height: "10px",
        alignSelf: "normal"
    },
    checkmark: {
        selectors: {
            ":hover": {
                border: "3px solid white"
            }
        }
    },
    root: {
        fontFamily: "Urbanist",
        marginLeft: "0px",
        selectors: {
            ":hover .ms-Checkbox-checkbox": {

            },
            ":hover .ms-Checkbox-checkmark": {

            },
            ".is-checked .ms-Checkbox-checkbox": {
                background: "#7e7e7e",
                border: "3px solid #7e7e7e"

            }
        }
    }
};

export const customPropInvIsKeyCheckStyles: Partial<ICheckboxStyles> = {
    text: {
        fontFamily: "Urbanist",
        fontSize: "10px",
        marginTop: "-1px",
        marginLeft: "-2px"
    },
    checkbox: {
        width: "14px",
        height: "14px",

    },
    label: {
        fontFamily: "Urbanist, Roboto",
        fontSize: "10px",
        width: "14px",
        height: "14px"
    },
    checkmark: {
        selectors: {
            ":hover": {
                border: "3px solid white"
            }
        }
    },
    root: {
        alignSelf: "center",
        alignItems: "center",

        fontFamily: "Urbanist",
        selectors: {
            ":hover .ms-Checkbox-checkbox": {

            },
            ":hover .ms-Checkbox-checkmark": {

            },
            ".is-checked .ms-Checkbox-checkbox": {
                background: "#7e7e7e",
                border: "3px solid #7e7e7e"

            }
        }
    }
};

export const webUploadThrottlingCheckboxStyles: Partial<ICheckboxStyles> = {
    text: {
        fontFamily: "Urbanist"
    },
    checkbox: {
        background: "white",
        border: "1px solid #333",
        color: "white",
        borderColor: "#333",
        selectors: {
            ":after": {
                content: '""',
                borderColor: "#333",
                background: "#333",
                color: "#333"
            },
            ":hover": {
                border: "3px solid #333"
            },
            ":focus": {
                border: "3px solid #333"
            },
            ":active": {
                border: "3px solid #333"
            }
        }
    },
    checkmark: {
        color: "white",
        background: "#333",
        border: "3px solid #333",
        selectors: {
            ":hover": {
                color: "white",
                border: "3px solid white"
            }
        }
    },
    root: {
        fontFamily: "Urbanist",
        selectors: {
            ":hover .ms-Checkbox-checkbox": {
                background: "#7e7e7e",
                border: "3px solid #7e7e7e"
            },
            ":hover .ms-Checkbox-checkmark": {
                background: "#7e7e7e",
                border: "1px solid #7e7e7e"
            },
            ".is-checked .ms-Checkbox-checkbox": {
                background: "#7e7e7e",
                border: "3px solid #7e7e7e"
            }
        }
    }
};

export const stackStyles: Partial<IStackStyles> = {
    root: {
        gap: 10,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 20,
        marginBottom: "20px",
        borderRadius: "15px",
        maxWidth: "100vw !important",
        marginLeft: "0px !important",
        marginRight: "0px !important"
    },
};

export const stackStylesAnalytics: Partial<IStackStyles> = {
    root: {
        gap: 2,
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 0,
        paddingBottom: 20,
        marginBottom: "20px",
        borderRadius: "15px",
        width: "calc(100vw)",
        justifyContent: "space-between"
    }
};

export const AddContentStackStyles: Partial<IStackStyles> = {
    root: {
        gap: 10,
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 0,
        paddingBottom: 20,
        marginBottom: "20px",
        borderRadius: "15px",
        width: "calc(100vw)"
    },
    inner: {
        height: "content",
        maxHeight: "70vh"


    }
};

export const stackStylesCompAdmin: Partial<IStackStyles> = {
    root: {
        gap: 10,
        marginLeft: "10px",
        marginRight: "10px"
    }
};

export const sliderStyles: Partial<ISliderStyles> = {
    root: { marginTop: "10px" },
    titleLabel: {
        fontFamily: "Urbanist"
    },
    valueLabel: {
        fontFamily: "Urbanist"
    },
    slideBox: {
        borderRadius: "5px",
        color: "#333",
        borderColor: "#333",

        selectors: {
            ":hover": {
                color: "#333"
            },
            ":active": {
                color: "#333"
            },
            ":hover .ms-Slider-active": {
                background: "rgb(241, 100, 30) !important"
            },
            ":hover .ms-Slider-thumb": {
                borderColor: "orange !important",
                background: "white !important"
            }
        }
    },

    thumb: {
        selectors: {
            borderColor: "orange !important",
            backrgoundColor: "orange",
            color: "orange",
            ":hover": {
                borderColor: "orange !important",
                backrgoundColor: "orange",
                color: "orange"
            },
            ":active": {
                borderColor: "orange !important"
            }
        }
    },
    line: {
        selectors: {
            ":hover": {
                background: "orange",
                backrgoundColor: "orange",
                color: "orange"
            },

            ":active": {
                color: "#333",
                borderColor: "#333",
                background: "#333",
                backgroundColor: "#333"
            }
        }
    },
    lineContainer: {
        selectors: {
            ":hover": {
                selectors: {
                    ".ms-Slider-active": {
                        background: "orange",
                        backrgoundColor: "orange",
                        borderColor: "#333",
                        color: "orange"
                    },
                    ":active": {
                        color: "#333",
                        borderColor: "#333",
                        background: "#333",
                        backgroundColor: "#333"
                    }
                }
            }
        }
    }
};

export const sendFeedbackDirectPrimaryButtonStyles: Partial<IButtonStyles> = {
    root: {
        borderRadius: "5px"
    }
};

export const dpaFieldConfButStyles: Partial<IButtonStyles> = {
    root: {
        borderRadius: "8px",
        height: "32px",
        width: "32px"
    }
};

export const actionButtonAddStyles: Partial<IButtonStyles> = {
    rootHovered: {
        color: "#ffffffbd !important"
    }
};

export const invFieldConfSaveButStyles: Partial<IButtonStyles> = {
    root: {
        borderRadius: "5px",
        transition: "transform 0.1s ease-in-out",
        backgroundColor: "#f1641e",
        color: "#fff"
    },
    rootHovered: {
        backgroundColor: "#BA487F",
        color: "#333",
        borderColor: "#BA487F",
        selectors: {
            ":hover": {
                backgroundColor: "#BA487F",
                color: "#fff",
                borderColor: "#BA487F",
                transform: "scale(1.05)",
                transition: "transform 0.1s ease-in-out"
            },
            ":active": {
                backgroundColor: "#EA5B6F",
                color: "#fff",
                borderColor: "#EA5B6F",
                transform: "scale(0.98)", // Makes the button smaller when pressed
            },

        }
    },
};

export const invFieldConfMainSaveButStyles: Partial<IButtonStyles> = {
    root: {
        fontFamily: "Raleway, Urbanist, Roboto",
        borderRadius: "10px",
        transition: "transform 0.05s ease-in-out",
        backgroundColor: "#f1641e",
        width: "200px !important",
        maxWidth: "50vw !important",
        boxShadow: "0px 4px 6px #00000029",
    },
    rootHovered: {
        backgroundColor: "#BA487F",
        color: "#333",
        borderColor: "#EA5B6F",
        selectors: {
            ":hover": {
                backgroundColor: "#BA487F",
                color: "#fff",
                borderColor: "#BA487F",
                transform: "scale(1.03)",
                transition: "transform 0.05s ease-in-out",
                boxShadow: "0px 6px 8px #0000003d"
            },
            ":active": {
                backgroundColor: "#801c4c",
                color: "#fff",
                borderColor: "#EA5B6F",
                transform: "scale(0.98)", // Makes the button smaller when pressed
            },
        }
    },

};

export const invFieldScenarioAddButStyles: Partial<IButtonStyles> = {
    root: {
        fontFamily: "Raleway, Urbanist, Roboto",
        borderRadius: "5px",
        transition: "transform 0.05s ease-in-out",
        boxShadow: "0px 4px 6px #00000029",
    },
    rootHovered: {

        color: "#333",
        backgroundColor: "#BA487F",
        selectors: {
            ":hover": {
                backgroundColor: "#BA487F",
                color: "#fff",
                borderColor: "#BA487F",
                transform: "scale(1.03)",
                transition: "transform 0.05s ease-in-out",
                boxShadow: "0px 6px 8px #0000003d"
            },
            ":active": {
                backgroundColor: "#801c4c",
                color: "#fff",
                borderColor: "#EA5B6F",
                transform: "scale(0.98)", // Makes the button smaller when pressed
            },
        }
    },

};

export const clipIcon: IIconProps = {
    iconName: "Attach",
    styles: {
        root: {
            color: "#333333",
            transform: "rotate(-20deg)",
            fontSize: "20px"
        }
    }
};

export const dropdownStylesDocExtr: Partial<IDropdownStyles> = {
    root: {
        padding: "0",
        margin: "-5px",
        borderRadius: "5px !important",
        borderColor: "#333",
        minWidth: "93px",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            }
        }
    },
    label: {
        fontFamily: "Urbanist",
        fontSize: "12px",
        borderRadius: "5px !important",
        width: "100%"
    },
    title: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",
        borderColor: "#333",
        fontSize: "12px",
        height: "32px",

        minWidth: "50px"
    },
    dropdown: {
        borderRadius: "5px !important",
        borderColor: "#333",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            }
        }
    },
    dropdownItem: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",
        fontSize: "12px",
        height: "30px"
    },
    dropdownItemSelected: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",

        fontSize: "12px",
        height: "30px"
    },
    caretDown: {
        borderRadius: "5px !important"
    }
};

export const dropdownFileSrcStylesDocExtr: Partial<IDropdownStyles> = {
    root: {
        maxWidth: "400px",
        width: "content",
        padding: "0",
        margin: "-5px",
        borderRadius: "5px !important",
        borderColor: "#333",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            }
        }
    },
    label: {
        fontFamily: "Urbanist",
        fontSize: "12px",
        borderRadius: "5px !important",
        width: "100%"
    },
    title: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",
        borderColor: "#333",
        fontSize: "12px",
        height: "32px",
        width: "100%",
        minWidth: "content",
        selectors: {
            // Placeholder style (targeting empty key)
            ":has(span.placeholder)": {
                color: "gray !important",
                fontStyle: "italic !important"
            }
        }
    },

    dropdown: {
        borderRadius: "5px !important",
        borderColor: "#333",

        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            }
        }
    },
    dropdownItem: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",
        fontSize: "12px",
        height: "30px"
    },
    dropdownItemSelected: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",
        fontSize: "12px",
        height: "30px"
    },
    caretDown: {
        borderRadius: "5px !important"
    }
};

export const dropdownFileNativeColorSrcStylesDocExtr: Partial<IDropdownStyles> = {
    root: {
        maxWidth: "400px",
        width: "content",
        padding: "0",
        margin: "-5px",
        borderRadius: "5px !important",

        selectors: {
            ":focus": {
                borderRadius: "5px !important",

            },
            ":hover": {
                borderRadius: "5px !important",

            },
            ":active": {
                borderRadius: "5px !important",

            },
            ":after": {
                borderRadius: "5px !important",

            },
            ":before": {
                borderRadius: "5px !important",

            }
        }
    },
    label: {
        fontFamily: "Urbanist",
        fontSize: "12px",
        borderRadius: "5px !important",

    },
    title: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",
        borderColor: "#333",
        fontSize: "12px",
        height: "32px",
        width: "100%",
        minWidth: "content",
        selectors: {
            // Placeholder style (targeting empty key)
            ":has(span.placeholder)": {
                color: "gray !important",
                fontStyle: "italic !important"
            }
        }
    },

    dropdown: {
        borderRadius: "5px !important",

        selectors: {
            ":focus": {
                borderRadius: "5px !important",
            },
            ":hover": {
                borderRadius: "5px !important",
            },
            ":active": {
                borderRadius: "5px !important",
            },
            ":after": {
                borderRadius: "5px !important",
            },
            ":before": {
                borderRadius: "5px !important",

            }
        }
    },
    dropdownItem: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",
        fontSize: "12px",
        height: "30px"
    },
    dropdownItemSelected: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",
        fontSize: "12px",
        height: "30px"
    },
    caretDown: {
        borderRadius: "5px !important"
    }
};

export const answerLengthOptionsStyles: Partial<IDropdownStyles> = {
    root: {
        maxWidth: "400px",
        width: "content",
        height: "20px",
        minHeight: "20px",
        lineHeight: " 20px",
        padding: "0",
        margin: "-5px",
        borderRadius: "5px !important",
        borderColor: "#333",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            }
        }
    },
    label: {
        fontFamily: "Urbanist",
        fontSize: "12px",
        borderRadius: "5px !important",
        width: "100%",
        height: "0px",
        minHeight: "10px",
        lineHeight: " 10px"
    },
    title: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",
        borderColor: "#333",
        fontSize: "12px",
        height: "20px",
        minHeight: "20px",
        lineHeight: " 18px",
        width: "100%",
        minWidth: "content",
        margin: "0px",

        selectors: {
            // Placeholder style (targeting empty key)
            ":has(span.placeholder)": {
                color: "gray !important",
                fontStyle: "italic !important"
            }
        }
    },

    dropdown: {
        borderRadius: "5px !important",
        borderColor: "#333",

        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            }
        }
    },
    dropdownItem: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",
        fontSize: "12px",
        height: "15px",
        minHeight: "15px",
        lineHeight: " 15px"
    },
    dropdownItemSelected: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",
        fontSize: "12px",
        height: "15px",
        minHeight: "15px",
        lineHeight: " 15px"
    },
    caretDown: {
        borderRadius: "5px !important",
        height: "15px",
        minHeight: "15px",
        lineHeight: " 15px"
    },
    caretDownWrapper: {
        height: "20px",
        minHeight: "20px",
        lineHeight: " 20px"
    }
};

export const dropdownFileSrcStylesInvoices: Partial<IDropdownStyles> = {
    callout: {
        width: "300px !important",
        minWidth: "400px !important",

        marginRight: 5
    },
    dropdown: {
        width: "200",
        minWidth: 0,
        maxWidth: "200px",
        borderRadius: "5px !important",
        borderColor: "#979797",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            }
        }
    },
    root: {
        width: "auto",
        marginTop: 3,
        marginRight: "5px",
        minWidth: 0,
        maxWidth: "none",
        borderRadius: "5px !important",
        borderColor: "#979797",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            }
        }
    },
    title: {
        width: "auto",
        borderRadius: "5px !important",
        borderColor: "#979797",
        minWidth: 0,
        maxWidth: "none"
    },
    dropdownItem: {
        width: "400px !important",
        minWidth: "400px !important"
    },
    dropdownItemSelected: {
        width: "400px !important",
        minWidth: "400px !important"
    },

    label: {
        width: "400px !important",
        minWidth: "400px !important"
    }
};

export const dropdownFileSrcStylesAnalyticsUsers: Partial<IDropdownStyles> = {
    callout: {
        width: "200px !important",
        minWidth: "200px !important",
        maxHeight: "200px"
    },
    label: {
        fontFamily: "Urbanist , Roboto !important",
        fontSize: "12px !important",
        borderRadius: "5px !important",
        width: "100%"
    },
    dropdown: {
        width: "auto",
        minWidth: 0,
        maxWidth: "200px",
        borderRadius: "5px !important",
        borderColor: "#979797",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            }
        }
    },
    root: {
        width: "200px",
        height: "70px",
        marginRight: "5px",
        minWidth: 0,
        maxWidth: "none",
        borderRadius: "5px !important",
        borderColor: "#979797",
        fontFamily: "Urbanist , Roboto !important",
        fontSize: "12px !important",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            }
        }
    },
    title: {
        width: "auto",
        borderRadius: "5px !important",
        borderColor: "#979797",
        minWidth: 0,
        maxWidth: "none",
                fontFamily: "Urbanist , Roboto !important",
        fontSize: "12px !important",
    },
    dropdownItem: {
        width: "200px !important",
        minWidth: "200px !important"
    },
    dropdownItemSelected: {
        width: "200px !important",
        minWidth: "200px !important"
    },
};

export const assitantCardsDropdownStyles: Partial<IDropdownStyles> = {
    root: {
        padding: "0",
        margin: "0 5px 0 0",
        borderRadius: "15px !important",
        color: "white",
        borderColor: "grey",
        width: "115px",
        selectors: {
            ":focus": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            },
            ":hover": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            },
            ":active": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            },
            ":after": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            },
            ":before": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            }
        }
    },
    label: {
        fontFamily: "Urbanist",
        fontSize: "12px",

        borderRadius: "15px !important",
        borderColor: "grey",
        width: "100%",
        color: "white !important",
        marginBottom: "5px"
    },
    title: {
        fontFamily: "Urbanist",
        borderRadius: "15px !important",
        borderColor: "grey",
        fontSize: "12px",
        height: "30px",
        width: "100%",
        background: "grey",
        color: "white !important",
        selectors: {
            ":focus": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white",
            },
            ":hover": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white !important"
            },
            ":active": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            },
            ":after": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            },
            ":before": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "#333"
            }
        }
    },
    dropdown: {
        borderRadius: "15px !important",
        color: "white",
        borderColor: "grey",
        selectors: {
            ":focus": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            },
            ":hover": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            },
            ":active": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            },
            ":after": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            },
            ":before": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            }
        }

    },
    dropdownItem: {
        fontFamily: "Urbanist",
        fontSize: "12px",
        height: "30px",
        color: "white",
        backgroundColor: "grey"
    },
    dropdownItemSelected: {
        fontFamily: "Urbanist",
        fontSize: "12px",
        height: "30px",
        color: "white",
        backgroundColor: "grey"
    },
    dropdownItemHeader: {
        fontFamily: "Urbanist",
        borderRadius: "15px !important",
        fontSize: "12px",
        height: "30px",
        color: "white !important"
    },
    caretDown: {
        borderRadius: "15px !important",
        color: "#333"
    }
};

export const assitantCardsDropdownWiderStyles: Partial<IDropdownStyles> = {
    root: {
        padding: "0",
        margin: "0 0 0 0",
        borderRadius: "15px !important",
        color: "white",
        borderColor: "grey",
        width: "145px",
        selectors: {
            ":focus": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            },
            ":hover": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            },
            ":active": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            },
            ":after": {
                borderRadius: "15px !important",
                borderColor: "#2f485838 !important",
                color: "white"
            },
            ":before": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            }
        }
    },
    label: {
        fontFamily: "Urbanist",
        fontSize: "12px",

        borderRadius: "15px !important",
        borderColor: "grey",
        width: "100%",
        color: "white !important",

    },
    title: {
        fontFamily: "Urbanist",
        lineHeight: "29px",
        borderRadius: "15px !important",
        borderColor: "grey",
        fontSize: "12px",
        height: "30px",
        width: "100%",
        background: "grey",
        color: "white !important",
        selectors: {
            ":focus": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white",
            },
            ":hover": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white !important"
            },
            ":active": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            },
            ":after": {
                borderRadius: "15px !important",
                borderColor: "#2f485838 !important",
                color: "white"
            },
            ":before": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "#333"
            }
        }
    },
    dropdown: {
        borderRadius: "15px !important",
        color: "white",
        borderColor: "grey",
        selectors: {
            ":focus": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            },
            ":hover": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white !important",
            },
            ":active": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            },
            ":after": {
                borderRadius: "15px !important",
                borderColor: "#2f485838 !important",
                color: "white"
            },
            ":before": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "#333"
            }
        }
    },
    dropdownItem: {
        fontFamily: "Urbanist",
        fontSize: "12px",
        height: "30px",
        color: "white",
        backgroundColor: "grey",
        selectors: {
            ":hover": {
                transition: "background-color 0.2s ease",
            }
        }
    },
    dropdownItemSelected: {
        fontFamily: "Urbanist",
        fontSize: "12px",
        height: "30px",
        color: "white",
        backgroundColor: "grey",
        selectors: {
            ":hover": {
                transition: "background-color 0.2s ease",
            }
        }
    },
    dropdownItemHeader: {
        fontFamily: "Urbanist",
        borderRadius: "15px !important",
        fontSize: "12px",
        height: "30px",
        color: "white !important"
    },
    caretDown: {
        borderRadius: "15px !important",
        color: "#333"
    }
};

export const assitantCardsDropdownThinStyles: Partial<IDropdownStyles> = {
    root: {
        padding: "0",
        margin: "0 0 0 0",
        borderRadius: "15px !important",
        color: "white",
        borderColor: "grey",
        width: "115px",
        selectors: {
            ":focus": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            },
            ":hover": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            },
            ":active": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            },
            ":after": {
                borderRadius: "15px !important",
                borderColor: "#2f485838 !important",
                color: "white"
            },
            ":before": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            }
        }
    },
    label: {
        fontFamily: "Urbanist",
        fontSize: "12px",

        borderRadius: "15px !important",
        borderColor: "grey",
        width: "100%",
        color: "white !important",

    },
    title: {
        fontFamily: "Urbanist",
        lineHeight: "29px",
        borderRadius: "15px !important",
        borderColor: "grey",
        fontSize: "12px",
        height: "30px",
        width: "100%",
        background: "grey",
        color: "white !important",
        selectors: {
            ":focus": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white",
            },
            ":hover": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white !important"
            },
            ":active": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            },
            ":after": {
                borderRadius: "15px !important",
                borderColor: "#2f485838 !important",
                color: "white"
            },
            ":before": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "#333"
            }
        }
    },
    dropdown: {
        borderRadius: "15px !important",
        color: "white",
        borderColor: "grey",

        selectors: {
            ":focus": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            },
            ":hover": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white !important",
            },
            ":active": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "white"
            },
            ":after": {
                borderRadius: "15px !important",
                borderColor: "#2f485838 !important",
                color: "white"
            },
            ":before": {
                borderRadius: "15px !important",
                borderColor: "#2F4858 !important",
                color: "#333"
            }
        }
    },
    dropdownItem: {
        fontFamily: "Urbanist",
        fontSize: "12px",
        height: "30px",
        color: "white",
        backgroundColor: "grey"
    },
    dropdownItemSelected: {
        fontFamily: "Urbanist",
        fontSize: "12px",
        height: "30px",
        color: "white",
        backgroundColor: "grey"
    },
    dropdownItemHeader: {
        fontFamily: "Urbanist",
        borderRadius: "15px !important",
        fontSize: "12px",
        height: "30px",
        color: "white !important"
    },
    caretDown: {
        borderRadius: "15px !important",
        color: "#333"
    }
};

export const dpaSearchStyles: Partial<ISearchBoxStyles> = {
    root: {
        width: 200,
        marginRight: 10,
        borderRadius: 9,
        border: '1px solid #cdcdcd !important',
        color: '#1f1f1f !important',
        selectors: {
            ":hover": {
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                border: "none"
            },
            ":hover:after": {
                border: "none"
            },
            "::after": {
                border: "none"
            },
            ":active": {
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",

                border: "none",
                borderRadius: 10
            },
            ":active:after": {
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",

                border: "none",
                borderRadius: 10
            }
        }
    },
    iconContainer: {
        color: '#1f1f1f !important',
        border: '1px solid #ffffff !important',
        borderRadius: 9,
        selector: {
            hover: { borderColor: '#cbcbcb' } ,
            active: { borderColor: '#adadad'},
            focus: { borderColor: '#adadad' },
        }
    },
    field: {
        color: '#1f1f1f !important',
        borderColor: '#ffffff !important',
        borderRadius: 9,
        selector: {
            hover: { borderColor: '#cbcbcb' } ,
            active: { borderColor: '#adadad'},
            focus: { borderColor: '#adadad' },
        }
    }
}

export const dropdownStyles: Partial<IDropdownStyles> = {
    root: {
        padding: "0",
        margin: "0",
        borderRadius: "5px !important",
        color: colorOne + " !important",
        borderColor: borderColorOne + " !important",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            }
        }
    },
    label: {
        fontFamily: "Urbanist",
        fontSize: "15px",
        borderRadius: "5px !important",
        borderColor: borderColorOne,
        width: "100%",
        marginBottom: "0px"
    },
    title: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",
        borderColor: borderColorOne + " !important",
        fontSize: "12px",
        height: "30px",
        width: "100%",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            }
        }
    },
    dropdown: {
        borderRadius: "5px !important",
        color: colorOne,
        borderColor: borderColorOne,
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            }
        }
    },
    dropdownItem: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",
        fontSize: "12px",
        height: "30px",
        color: colorOne
    },

    dropdownItemSelected: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",

        fontSize: "12px",
        height: "30px",
        color: colorOne
    },
    caretDown: {
        borderRadius: "5px !important",
        color: colorOne
    }
};

export const dropdownCampaignStyles: Partial<IDropdownStyles> = {
    root: {
        padding: "0",
        paddingTop: "4px",
        margin: "0",
        borderRadius: "8px !important",
        color: colorOne + " !important",
        borderColor: borderColorOne + " !important",
        selectors: {
            ":focus": {
                borderRadius: "8px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":hover": {
                borderRadius: "8px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":active": {
                borderRadius: "8px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":after": {
                borderRadius: "8px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":before": {
                borderRadius: "8px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            }
        }
    },
    label: {
        fontFamily: "Urbanist",
        fontSize: "15px",
        borderRadius: "8px !important",
        borderColor: borderColorOne,
        width: "100%",
        marginBottom: "0px"
    },
    title: {
        fontFamily: "Urbanist",
        borderRadius: "8px !important",
        borderColor: borderColorOne + " !important",
        fontSize: "12px",
        height: "36px",
        width: "100%",
        paddingTop: "1px",
        selectors: {
            ":focus": {
                borderRadius: "8px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":hover": {
                borderRadius: "8px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":active": {
                borderRadius: "8px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":after": {
                borderRadius: "8px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":before": {
                borderRadius: "8px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            }
        }
    },
    dropdown: {
        borderRadius: "8px !important",
        color: colorOne,
        borderColor: borderColorOne,
        selectors: {
            ":focus": {
                borderRadius: "8px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":hover": {
                borderRadius: "8px",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":active": {
                borderRadius: "8px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":after": {
                borderRadius: "8px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":before": {
                borderRadius: "8px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            }
        }
    },
    dropdownItem: {
        fontFamily: "Urbanist",
        borderRadius: "8px !important",
        fontSize: "12px",
        height: "36px",
        color: colorOne
    },

    dropdownItemSelected: {
        fontFamily: "Urbanist",
        borderRadius: "8px !important",

        fontSize: "12px",
        paddingTop: "2px !important",
        color: colorOne
    },
    caretDown: {
        borderRadius: "8px !important",
        color: colorOne,

    },
    caretDownWrapper:{
        paddingTop: "2px",
    },
    callout:{
        borderRadius: "8px !important",
    }
};



export const dropdownDPAStyles: Partial<IDropdownStyles> = {
    root: {
        padding: "0",
        margin: "0",
        borderRadius: "5px !important",

        color: colorOne + " !important",
        borderColor: borderColorOne + " !important",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            }
        }
    },
    label: {
        fontFamily: "Urbanist",
        fontSize: "15px",
        borderRadius: "5px !important",
        borderColor: borderColorOne,
        width: "100%",
        marginBottom: "0px"
    },
    title: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",
        borderColor: borderColorOne + " !important",
        fontSize: "12px",
        height: "30px",
        width: "100%",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            }
        }
    },
    dropdown: {
        borderRadius: "5px !important",
        minWidth: "150px",
        color: colorOne,
        borderColor: borderColorOne,
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            }
        }
    },
    dropdownItem: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",
        fontSize: "12px",
        height: "30px",
        color: colorOne
    },

    dropdownItemSelected: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",

        fontSize: "12px",
        height: "30px",
        color: colorOne
    },
    caretDown: {
        borderRadius: "5px !important",
        color: colorOne
    }
};


export const dropdownStylesGenAiQs: Partial<IDropdownStyles> = {
    callout: {
        height: "300px"
    },
    root: {
        padding: "0",
        margin: "0",
        borderRadius: "5px !important",
        color: "#333",
        borderColor: "#333",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            }
        }
    },
    label: {
        fontFamily: "Urbanist",
        fontSize: "15px",
        borderRadius: "5px !important",
        borderColor: "#333",
        width: "100%",
        marginBottom: "5px"
    },
    title: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",
        borderColor: "#333",
        fontSize: "12px",
        height: "30px",
        width: "100%"
    },

    dropdown: {
        borderRadius: "5px !important",

        color: "#333",
        borderColor: "#333",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            }
        }
    },
    dropdownItem: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",
        fontSize: "12px",
        height: "30px",
        color: "#333"
    },

    dropdownItemSelected: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",

        fontSize: "12px",
        height: "30px",
        color: "#333"
    },
    caretDown: {
        borderRadius: "5px !important",
        color: "#333"
    }
};

export const dropdownContentTypeStyles: Partial<IDropdownStyles> = {
    root: {
        padding: "5px",
        margin: "0",
        borderRadius: "5px !important",
        color: "#333",
        borderColor: "#333",
        width: "content",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            }
        }
    },
    label: {
        fontFamily: "Urbanist",
        fontSize: "14px",
        borderRadius: "5px !important",
        borderColor: "#2F4858",
        marginRight: "10px",
        marginTop: "2px"
    },
    title: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",
        borderColor: "#333",
        fontSize: "12px",
        height: "30px",
        width: "100%"
    },

    dropdown: {
        borderRadius: "5px !important",
        color: "#333",
        width: "150px",
        borderColor: "#333",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            }
        }
    },
    dropdownItem: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",
        fontSize: "12px",
        height: "30px",
        color: "#333"
    },

    dropdownItemSelected: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",

        fontSize: "12px",
        height: "30px",
        color: "#333"
    },
    caretDown: {
        borderRadius: "5px !important",
        color: "#333"
    }
};

export const dropdownDetailsListStyles: Partial<IDropdownStyles> = {
    dropdownItems: {
        maxHeight: "60vh !important",
    },
    root: {
        marginTop: "-5px",
        marginBottom: "-5px",
        height: "30px",
        marginLeft: "-5px",
        borderRadius: "5px !important",
        color: "#333",
        paddingLeft: "2px",
        paddingTop: "0px",
        borderColor: "#333",
        minWidth: "100px",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            }
        }
    },
    label: {
        borderRadius: "5px !important",
        borderColor: "#333",
        width: "100%",
        padding: "0px"

    },
    title: {
        font: "normal normal 13px/28px Urbanist,Roboto",
        borderRadius: "5px !important",
        paddingLeft: "6px",
        paddingTop: "0px",
        marginTop: "-4px",
        marginBottom: "-4px",
        borderColor: "#333",
        fontSize: "12px",
        height: "30px",

        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },

    dropdown: {
        borderRadius: "5px !important",
        color: "#333",
        borderColor: "#333",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            }
        }
    },
    dropdownItem: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",
        fontSize: "12px",
        height: "30px",
        color: "#333"
    },

    dropdownItemSelected: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",

        fontSize: "12px",
        height: "30px",
        color: "#333"
    },
    caretDown: {
        borderRadius: "5px !important",
        color: "#333"
    }
};

export const dropdownStylesSpaceUserListV2: Partial<IDropdownStyles> = {
    root: {
        padding: "0",
        margin: "0",
        borderRadius: "5px",
        selectors: {
            ":focus": {
                borderRadius: "5px"
            },
            ":hover": {
                borderRadius: "5px"
            },
            ":active": {
                borderRadius: "5px"
            }
        }
    },
    label: {
        fontFamily: "Urbanist",
        fontSize: "7px",
        borderRadius: "5px"
    },
    title: {
        fontFamily: "Urbanist",
        borderRadius: "5px",
        fontSize: "12px",
        height: "30px"
    },

    dropdown: {
        borderRadius: "5px",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderWidth: "2px !important",
                borderColor: "#333 !important"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderWidth: "2px !important",
                borderColor: "#333 !important"
            },
            ":active": {
                borderRadius: "5px !important",
                borderWidth: "2px !important",
                borderColor: "#333 !important"
            },
            ":after": {
                borderRadius: "5px !important",
                borderWidth: "2px !important",
                borderColor: "#333 !important"
            },
            ":before": {
                borderRadius: "5px !important",
                borderWidth: "2px !important",
                borderColor: "#333 !important"
            }
        }
    },
    dropdownItem: {
        fontFamily: "Urbanist",
        borderRadius: "5px",
        fontSize: "12px",
        height: "30px"
    },

    dropdownItemSelected: {
        fontFamily: "Urbanist",
        borderRadius: "5px",
        fontSize: "12px",
        height: "30px"
    },
    caretDown: {
        borderRadius: "5px"
    }
};

export const dropdownStylesInvUser: Partial<IDropdownStyles> = {
    root: {
        padding: "0",
        margin: "0",
        borderRadius: "5px",
        selectors: {
            ":focus": {
                borderRadius: "5px"
            },
            ":hover": {
                borderRadius: "5px"
            },
            ":active": {
                border: "none !important",
                outline: "none !important"
            }
        }
    },

    label: {
        fontFamily: "Urbanist",
        fontSize: "13px",
        borderRadius: "5px"
    },
    title: {
        fontFamily: "Urbanist",
        borderRadius: "5px",
        fontSize: "12px",
        height: "30px"
    },

    dropdown: {
        borderRadius: "5px",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderWidth: "2px !important",
                borderColor: "#333 !important"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderWidth: "2px !important",
                borderColor: "#333 !important"
            },
            ":active": {
                borderRadius: "5px !important",
                borderWidth: "2px !important",
                borderColor: "#333 !important"
            },
            ":after": {
                borderRadius: "5px !important",
                borderWidth: "2px !important",
                borderColor: "#333 !important"
            },
            ":before": {
                borderRadius: "5px !important",
                borderWidth: "2px !important",
                borderColor: "#333 !important"
            }
        }
    },
    dropdownItem: {
        fontFamily: "Urbanist",
        borderRadius: "5px",
        fontSize: "12px",
        height: "30px"
    },

    dropdownItemSelected: {
        fontFamily: "Urbanist",
        borderRadius: "5px",
        fontSize: "12px",
        height: "30px"
    },
    caretDown: {
        borderRadius: "5px"
    }
};

export const dropdownStylesCompAdmin: Partial<IDropdownStyles> = {
    root: {
        padding: "0",
        margin: "0",
        borderRadius: "5px !important",
        color: "#333",
        borderColor: "#333",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            }
        }
    },
    label: {
        fontFamily: "Urbanist",
        fontSize: "15px",
        borderRadius: "5px !important",
        borderColor: "#333",
        width: "100%",
        marginBottom: "5px"
    },
    title: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",
        borderColor: "#333",
        fontSize: "12px",
        height: "30px",
        width: "100%"
    },

    dropdown: {
        borderRadius: "5px !important",
        color: "#333",
        borderColor: "#333",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: "#333 !important",
                color: "#333"
            }
        }
    },
    dropdownItem: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",
        fontSize: "12px",
        height: "30px",
        color: "#333"
    },

    dropdownItemSelected: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",

        fontSize: "12px",
        height: "30px",
        color: "#333"
    },
    caretDown: {
        borderRadius: "5px !important",
        color: "#333"
    }
};

export const dropdownAddContSyncStyles: Partial<IDropdownStyles> = {
    dropdownItems: {
        maxHeight: "60vh !important",
    },
    root: {
        fontFamily: "Raleway, Urbanist , Roboto !important",
        padding: "0",
        margin: "0",
        borderRadius: "5px !important",
        color: colorOne + " !important",
        borderColor: borderColorOne + " !important",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            }
        }
    },
    label: {
        fontFamily: "Raleway, Urbanist , Roboto !important",
        fontSize: "15px",
        borderRadius: "5px !important",
        borderColor: borderColorOne,
        width: "100%",
        marginBottom: "0px"
    },
    title: {
        fontFamily: "Raleway, Urbanist , Roboto !important",
        borderRadius: "5px !important",
        borderColor: borderColorOne + " !important",
        fontSize: "12px",
        height: "30px",
        width: "100%",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            }
        }
    },
    dropdown: {
        borderRadius: "5px !important",
        color: colorOne,
        borderColor: borderColorOne,
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: borderColorOne + " !important",
                color: colorOne + " !important"
            }
        }
    },
    dropdownItem: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",
        fontSize: "12px",
        height: "30px",
        color: colorOne
    },

    dropdownItemSelected: {
        fontFamily: "Urbanist",
        borderRadius: "5px !important",
        fontSize: "12px",
        height: "30px",
        color: colorOne
    },
    caretDown: {
        borderRadius: "5px !important",
        color: colorOne
    }
};

export const prdAssistantExternalFileListStyle: Partial<IDocumentCardPreviewStyles> = {
    root: {
        margin: "0px",
        overflow: "hidden",
        borderRadius: "5px",
        padding: "0px",
        overflowY: "hidden"
    }
};

export const chatAdmPivotStyles: Partial<IPivotStyles> = {
    root: {
        width: "100%",
        minWidth: "100%"
    },
    itemContainer: {
        width: "100%"
    },
    link:{
        fontFamily: "Raleway, Urbanist , Roboto",
        animation: "fadeIn 0.3s ease-in-out"
    },
    linkIsSelected: {
        fontFamily: "Raleway, Urbanist , Roboto",
        animation: "fadeInFromBottom 0.3s ease-in-out"
    }

};

export const tooltipStylesThumbInScopeChooser: Partial<ITooltipStyles> = {
    root: {
        borderRadius: "5px",
        overflow: "hidden"
    }
};

export const panelRowStyles: Partial<IPanelStyles> = {
    headerText: {
        fontSize: "24px",
        fontFamily: "Urbanist"
    }
};

export const historyPanelStyles: Partial<IPanelStyles> = {
    headerText: {
        fontSize: "24px",
        fontFamily: "Urbanist"
    }
};

export const tooltipHostStyles: Partial<ITooltipHostStyles> = {
    root: {
        borderRadius: "4px"
    }
};

export const tooltipListThumbStyles: Partial<ITooltipHostStyles> = {
    root: {
        borderRadius: "4px",
        maxWidth: "80vw",
        maxHeight: "80vh",
    }
};

export const textFieldStylesDocExtrDPA: Partial<ITextFieldStyles> = {
    field: {

        fontSize: "12px",
        fontFamily: "Urbanist, Roboto"
    },
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist"
            }
        }
    },
    root: {
        borderRadius: "5px"
    },
    fieldGroup: {



        borderRadius: "5px",
        selectors: {
            "::after": {
                borderRadius: "5px ",
                border: "1px solid #333"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const visibilityCalloutContentStyles: Partial<ICalloutContentStyles> = {
    root: {
        backgroundColor: "#333",
        borderRadius: 7,
        border: "none",
        overflow: "hidden"
    },
    container: {
        borderRadius: 7,
        border: "none"
    },
    calloutMain: {
        borderRadius: 7
    }
};

export const calloutContentFeedbackDirectStyles: Partial<ICalloutContentStyles> = {
    root: {
        padding: "0px !important",
        margin: "0px",
        borderWidth: "0px !important",
        borderRadius: 10,
        overflow: "visible",
        boxShadow: "0px 0px 0px 0px rgba(84, 84, 84, 0.07) !important",
        backgroundColor: "#ffffffff"
    },
    container: {
        top: "0px !important",
        position: "fixed",
        borderRadius: 15,
        overflow: "visible",

        boxShadow: "0px 0px 0px 0px rgba(84, 84, 84, 0.07) !important",
        backgroundColor: "#ffffffff",
        borderWidth: "0px !important",

    },
    calloutMain: {
        borderWidth: "0px !important",
        borderRadius: 15,

        overflow: "visible",
        boxShadow: "0px 0px 0px 0px rgba(84, 84, 84, 0.07) !important",
        backgroundColor: "#ffffffff",
        color: "#ffffffff"

    }
};

export const calloutContentRecoProcessStyles: Partial<ICalloutContentStyles> = {
    root: {
        padding: "0px !important",
        margin: "0px",
        borderWidth: "0px !important",
        borderRadius: 10,
        overflow: "hidden",

        boxShadow: "0px 0px 0px 0px rgba(84, 84, 84, 0.07) !important",
        backgroundColor: "#ffffffff",

    },
    container: {
        top: "0px !important",
        position: "fixed",
        borderRadius: 15,
        overflow: "visible",

        boxShadow: "0px 0px 0px 0px rgba(84, 84, 84, 0.07) !important",
        backgroundColor: "#ffffffff",
        borderWidth: "0px !important",

    },
    calloutMain: {
        borderWidth: "0px !important",
        borderRadius: 15,

        overflow: "visible",
        boxShadow: "0px 0px 0px 0px rgba(84, 84, 84, 0.07) !important",
        backgroundColor: "#ffffffff",
        color: "#ffffffff"

    }
};

export const invRecoCalloutStyles: Partial<ICalloutContentStyles> = {
    root: {
        padding: "0px !important",
        margin: "0px",
        borderWidth: "0px !important",
        borderRadius: "10px !important",
        overflow: "hidden",

        boxShadow: "0px 0px 0px 0px rgba(84, 84, 84, 0.07) !important",
        background: "transparent",
        transition: "background 180ms cubic-bezier(0.4, 0, 0.2, 1)",

    },
    container: {
        top: "0px !important",
        position: "fixed",
        height: "auto",
        borderRadius: "10px",
        boxShadow: "0px 0px 0px 0px rgba(84, 84, 84, 0.07) !important",
        borderWidth: "0px !important",

    },
    calloutMain: {
        minWidth: "300px",
        height: "auto",
        overflow: "hidden",
        borderWidth: "0px !important",
        borderRadius: "10px",
        boxShadow: "0px 0px 0px 0px rgba(84, 84, 84, 0.07) !important",
    }
};

export const addUrlCallout:Partial<ICalloutContentStyles> = {
    root: {
        borderRadius: "5px"
    },
    calloutMain: {
        borderRadius: "5px"
    },
    beakCurtain: { borderRadius: "5px" },
    beak: { borderRadius: "1px" }
};

export const addSyncCalloutStyles:Partial<ICalloutContentStyles> = {
    root: {
        borderRadius: "8px",
        boxShadow: "rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;",

    },
    calloutMain: {
        borderRadius: "8px",
        overflow: "hidden"
    },
    beakCurtain: { borderRadius: "5px" },
    beak: { borderRadius: "1px" }
};

export const srcKeyCalloutStyles: Partial<ICalloutContentStyles> = {
    root: {
        borderRadius: "8px",
        boxShadow: "rgba(0, 0, 0, 0.15) 0px 8px 24px 0px, rgba(0, 0, 0, 0.08) 0px 1px 3px 0px",
        fontFamily: "Raleway, Urbanist, Roboto, sans-serif"
    },
    calloutMain: {
        borderRadius: "8px",
        overflow: "hidden",
        fontFamily: "Raleway, Urbanist, Roboto, sans-serif"
    },
    beakCurtain: { borderRadius: "8px" }
};

export const srcKeyCalloutInnerStyles = mergeStyleSets({
    container: {
        padding: "14px 16px",
        maxWidth: 300,
        fontFamily: "Raleway, Urbanist, Roboto, sans-serif"
    },
    title: {
        margin: 0,
        fontSize: 13,
        fontWeight: 700,
        color: "#3e7798",
        fontFamily: "Raleway, Urbanist, Roboto, sans-serif",
        textTransform: "uppercase",
        letterSpacing: "0.3px"
    },
    description: {
        fontSize: 11.5,
        lineHeight: "16px",
        color: "#605e5c",
        fontFamily: "Raleway, Urbanist, Roboto, sans-serif"
    }
});

export const textFieldStylesSpaceUserInvListV2 = {
    root: {
        borderRadius: "5px"
    },
    fieldGroup: {
        borderRadius: "5px",
        selectors: {
            "::after": {
                borderRadius: "5px ",
                border: "2px solid #404040"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

export const controlStylesAnalyticsConvoList = {
    root: {
        paddingTop: "0px !important",
        width: "calc(80vw - 20px)",
        minWidth: "70vw",
        maxWidth: "100vw",
        overflowY: "scroll",
        height: "100%"
    },
    commandButton: {
        marginRight: "20px",
        marginBottom: "20px"
    },
    headerWrapper: {
        position: "sticky",
        top: 0,
        zIndex: 1,
        borderRadius: "5px 5px 0 0"
    } as IStyle,
    detailsHeader: { padding: "0px" }
};

export const dropdownAnalyticsPeriod: Partial<IDropdownStyles> = {
    callout: {
        width: "200px !important",
        minWidth: "200px !important",
        maxHeight: "200px"
    },
    label: {
        fontFamily: "Urbanist , Roboto !important",
        fontSize: "12px !important",
        borderRadius: "5px !important",
        width: "100%"
    },
    dropdown: {
        width: "auto",
        minWidth: 0,
        maxWidth: "200px",
        borderRadius: "5px !important",
        borderColor: "#979797",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            }
        }
    },
    root: {
        width: "100px",
        height: "70px",
        padding: "5px",
        marginRight: "5px",
        minWidth: 0,
        maxWidth: "none",
        borderRadius: "5px !important",
        borderColor: "#979797",
        fontFamily: "Urbanist , Roboto !important",
        fontSize: "12px !important",
        selectors: {
            ":focus": {
                borderRadius: "5px !important",
                borderColor: "#333 !important"
            },
            ":hover": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            },
            ":active": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            },
            ":after": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            },
            ":before": {
                borderRadius: "5px !important",
                borderColor: "#979797 !important"
            }
        }
    },
    title: {
        width: "auto",
        borderRadius: "5px !important",
        borderColor: "#979797",
        minWidth: 0,
        maxWidth: "none",
                fontFamily: "Urbanist , Roboto !important",
        fontSize: "12px !important",
    },
    dropdownItem: {
        width: "200px !important",
        minWidth: "200px !important"
    },
    dropdownItemSelected: {
        width: "200px !important",
        minWidth: "200px !important"
    },
};

export const textFieldStylesAnalyticsConvoList = {
    callout: { "& .ms-current-active-month": { fontWight: "bold", backgroundColor: "red" } },
    root:{
        height: "70px",
        padding: "5px",
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "12px",
                fontFamily: "Urbanist"
            }
        }
    },
    fieldGroup: {
        margin: "0px 15px 15px 0px",
        borderRadius: "5px",
        selectors: {
            ":after": {
                borderRadius: "5px"
            },
            ":hover": {
                borderRadius: "5px"
            }
        }
    },
    field: {
        borderRadius: "5px"
    }
};

export const tooltipZoomMngPdfStyles: Partial<ITooltipStyles> = {

    root: {
        borderRadius: "5px",
        zIndex: 91003,
        height: "20px !important"
    },
    content: {
        borderRadius: "5px"
    }
};

export const tooltipZoomMngPdfDedicatedStyles: Partial<ITooltipStyles> = {
    root: {
        borderRadius: "5px",
        zIndex: 91003,
    },
    content: {
        borderRadius: "5px"
    }
};


export const visInfoToolStylesTurbo: Partial<ITooltipStyles> = {
    root: {
        borderRadius: "5px",
        zIndex: 9999999,
        height: "20px !important",
        position: "relative"
    },
    content: {
        borderRadius: "5px",
        zIndex: 999999,
        position: "relative"
    }
};

export const invWarnDynTooltip: Partial<ITooltipStyles> = {

    root: {
        borderRadius: "5px",
        zIndex: 999999,
        height: "content",
        position: "relative"
    },
    content: {
        borderRadius: "5px",
        zIndex: 9999999,
        position: "relative",
        width: "1600px"
    }
};

export const tooltipStyles  = {
    styles: {
        root: {
            borderRadius: "5px",
            width: "auto",

        },
        beak: {
            left: "20px !important",
            right: "auto !important"
        },
        beakCurtain: {
            borderRadius: "5px"
        },
        calloutMain: {
            borderRadius: "5px",

        },

    }
};



export const tooltipNoBeakStyles = {
    styles: {
        root: {
            borderRadius: "5px"
        },
        calloutMain: {
            borderRadius: "5px"
        },
        beakCurtain: {
            borderRadius: "5px"
        },
        beak: {
            zIndex: 0
        }
    }
};

export const assistantTypeDocCardStyles = {
    root: {
        transition: "box-shadow 0.1s ease-in-out, transform 0.03s ease-in-out",
        border: "none",
        selectors: {
            ":hover": {
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                border: "none"
            },
            ":hover:after": {
                border: "none"
            },
            ":active": {
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                border: "none"
            },
            ":active:after": {
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                border: "none"
            }
        }
    }
};

export const libPivotStyles: Partial<IPivotStyles> = {
    root: {
        paddingLeft: "10px",
        width: "100vw",
        minWidth: "100vw",
        fontFamily: "Urbanist, Roboto",
        fontSize: "14px",
        backgroundColor: "#f8f8f8",
        height: "48px",
        boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
        zIndex: 5
    },

    itemContainer: {
        width: "100vw",
        BiBorderRadius: "5px"
    },
    link: {
        fontFamily: "Urbanist, Roboto",
        fontSize: "14px",
        selectors: {
            "&::before": {},
            "&:hover::before": {
                backgroundColor: "orange" // Change this to your desired hover color
            },
            "&:hover": {
                transition: "background-color 0.2s ease"
            },
            "&:active": {
                backgroundColor: "rgba(76, 76, 76, 0.106)", // Change this to your desired active color
                transition: "background-color 0.2s ease"
            }
        }
    },
    linkIsSelected: {
        selectors: {
            "&::before": {
                backgroundColor: "orange" // change this to your desired selected color
            }
        }
    }
};

export const libPivotHiddenStyles: Partial<IPivotStyles> = {
    root: {
        width: "100%",
        minWidth: "100%",
        fontFamily: "Urbanist, Roboto",
        fontSize: "14px",
        backgroundColor: "#f8f8f8",
        height: "48px"
    },
    itemContainer: {
        width: "100%",
        BiBorderRadius: "5px"
    },
    link: {
        fontFamily: "Urbanist, Roboto",
        fontSize: "14px",
        selectors: {
            "&::before": {},
            "&:hover::before": {
                backgroundColor: "orange" // Change this to your desired hover color
            },
            "&:hover": {
                transition: "background-color 0.2s ease"
            }
        }
    },
    linkIsSelected: {
        selectors: {
            "&::before": {
                backgroundColor: "orange" // Change this to your desired selected color
            }
        }
    }
};

export const addUrlYouTubeCallout = {
    root: {
        borderRadius: "5px"
    },
    calloutMain: {
        borderRadius: "5px"
    },
    beakCurtain: { borderRadius: "5px" },
    beak: { borderRadius: "1px" }
};

export const addUrlPrimaryButton: IButtonStyles = {
    root: {
        borderRadius: "7px",
        borderColor: "#f1a41e00",
        boxShadow: "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;",
    },
    flexContainer: {
        fontFamily: "Raleway, Urbanist, Roboto",
        boxShadow: "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;",
    },
    rootHovered: {
        // Styles When Hovered and NOT Disabled

        border: "1px solid rgba(241, 100, 30, 0)",
        selectors: {
            "&:not(.is-disabled)": {
                backgroundColor: "#f1a41e",
                filter: "brightness(100%)",
                transition: "background-color 0.2s ease, filter 0.2s ease"
            },
            "&:not(.is-disabled):hover": {
                border: "1px solid #f1a41e",
                filter: "brightness(120%)",
                transition: "filter 0.2s ease"
            },

        }
    }
};

export const addScenPrimaryButton: IButtonStyles = {
    root: {
        borderRadius: "7px",
        border:"none",
        fontFamily: "Raleway, Urbanist, Roboto !important",
        boxShadow: "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;",
    },
    label: {
        fontFamily: "Raleway, Urbanist, Roboto",
    },
    flexContainer: {
        fontFamily: "Raleway, Urbanist, Roboto",
        boxShadow: "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;",
    },
    rootHovered: {
        // Styles When Hovered and NOT Disabled
        border: "none !important",
        selectors: {
            "&:not(.is-disabled)": {
                filter: "brightness(100%)",
                transition: "background-color 0.2s ease, filter 0.2s ease",
                border: "none",
            },
            "&:not(.is-disabled):hover": {
                border: "none",
                transition: "filter 0.2s ease",
            },

        }
    }
};

export const siteMapPrimaryButton = {
    root: {
        minWidth: "0px !important"
    },
    rootHovered: {
        // Styles When Hovered and NOT Disabled
        backgroundColor: "#f1a41e",

        selectors: {
            "&:not(.is-disabled)": {
                backgroundColor: "#f1a41e"
            }
        }
    }
};

export const newSpaceDocCardStyles = {
    root: {
        width: 300,
        paddingBottom: "20px",

        marginBottom: -10,
        marginTop: 30,
        borderRadius: 10,
        textAlign: "center",
        border: "none",
        backgroundColor: "rgba(193, 200, 214,0.16)",
        transition: "box-shadow 0.1s ease-in-out, transform 0.03s ease-in-out",
        selectors: {
            ":hover": {
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                border: "none"
            },
            ":hover:after": {
                border: "none"
            },
            ":active": {
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                transform: "translateY(4px)",
                border: "none",
                borderRadius: 10
            },
            ":active:after": {
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                transform: "translateY(2px)",
                border: "none",
                borderRadius: 10
            }
        }
    }
};

export const newSpaceDocTitleCardStyles = {
    root: {
        font: "normal normal 1000 18px/22px Urbanist, Roboto",
        color: "#485a73",
        textAlign: "center",
        marginBottom: -8,
        height: "auto"
    }
};

export const uploadCardStyles = {
    root: {
        marginBottom: 0,
        marginTop: 20,
        height: "auto",
        borderRadius: 10,
        padding: "10px 20px 10px 20px",
        position: "relative" as "relative",
        opacity: 0.9,
        selectors: {
            ":hover": {
                transform: "translateY(-2px)",
                transition: "transform 0.2s ease-out"
            },
            ":active": {
                transform: "translateY(-2px) scale(0.99)",
                transition: "transform 0.1s ease-out",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)"
            },
            ":hover:after": {
                border: "none"
            }
        }
    }
};

export const actionButtonStyles = {
    iconHovered: { color: "#333333" }
};

export const questionInputUploadCallout = {
    root: {
        height: "auto",
        borderRadius: "5px",
        backgroundColor: "rgba(255, 255, 255, 0)"
    },
    calloutMain: {
        borderRadius: "5px",
        paddingTop: "0px"
    },
    beakCurtain: { borderRadius: "5px" },
    beak: { borderRadius: "1px" }
};

export const diffCalloutStyles = {
    root: {
        height: "auto",
        borderRadius: "5px",
        backgroundColor: "rgba(255, 255, 255, 0.479)",
        border: "1px solid #2F4858",
        padding: "10px",
        fond: "normal normal 15px/20px Urbanist,Roboto"
    },
    calloutMain: {
        borderRadius: "5px"
    },
    beakCurtain: { borderRadius: "5px" },
    beak: { borderRadius: "1px" }
};

export const diffOvrvuCalloutStyles = {
    root: {
        height: "auto",
        borderRadius: "5px",
        backgroundColor: "rgba(255, 255, 255, 0.479)",
        border: "1px solid #2F4858",
        padding: "20px",
        maxHeight: "60vh"
    },
    calloutMain: {
        borderRadius: "5px"
    },
    beakCurtain: { borderRadius: "5px" },
    beak: { borderRadius: "1px" }
};

export const questionInputTextArea = {
    root: {
        verticalAlign: "middle",
        height: "0px"
    },
    fieldGroup: { minHeight: "0px", height: "0px" },
    field: {
        paddingTop: "11px",
        paddingBottom: "11px",
        height: "0px",
        minHeight: "0",
        selectors: {
            ":disabled": {
                backgroundColor: "#ffaf87",
                color: "red",
                font: "normal normal 17px/20px Urbanist,Roboto"
            }
        },
        font: "normal normal 15px/20px Urbanist,Roboto;"
    }
};

export const inviteUserTextFieldStyles = {
    root: { borderRadius: "5px" },
    fieldGroup: {
        borderRadius: "5px",
        selectors: {
            "::after": {
                borderRadius: "5px ",
                border: "2px solid #404040"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist, Raleway, Urbanist, Roboto,sans-serif"
            }
        }
    }
};

export const inviteUserCalloutStyles = {
    root: { width: 300, borderRadius: "10px" },
    calloutMain: { borderRadius: "10px" },
    beakCurtain: { borderRadius: "10px" }
};

export const playButStyles = {
    root: {
        borderRadius: "5px",
        color: "rgb(64, 84, 128);",
        margin: "5px 5px"
    }
};

export const pauseButStyles = {
    root: {
        borderRadius: "5px",
        color: "rgb(64, 84, 128);",
        margin: "5px 5px"
    }
};

export const zoomInOutViewer = {
    root: {
        borderRadius: "5px",
        color: "rgb(64, 84, 128);",
        margin: "5px 2px",
        zIndex: 99999
    },

};

export const closeButStyles = {
    root: {
        borderRadius: "5px",
        color: "orange",
        selectors: {
            ":disabled": {
                backgroundColor: "#fff",
                color: "grey",
                font: "normal normal 17px/20px Urbanist,Roboto",
                hover: {
                    backgroundColor: "#fff",
                    color: "grey"
                }
            },
            ":hover": {
                "not(:disabled)": {
                    backgroundColor: "rgba(255, 165, 0, 0.1)",
                    color: "orange",
                    transition: "background-color 0.2s ease"
                }
            }
        }
    }
};

export const analysisCloseButStyles = {
    root: {
        color: "orange",
        padding: "0px 0px 0px 0px",
        margin: "0px 0px 0px 0px",
        height: "25px",
        transition: "box-shadow 0.1s ease-in-out, transform 0.03s ease-in-out",
        selectors: {
            ":active": {
                boxShadow: "0 8px 16px 0 rgba(47, 72, 88, 0.219)",
                transform: "translateY(1px)"
            },
            ":hover": {
                boxShadow: "0 8px 14px 0 rgba(47, 72, 88, 0.486), 0 10px 26px 0 rgba(47, 72, 88, 0.444)"
            }
        }
    }
};

export const analysisOptionsStyles = {
    root: {
        color: "orange",
        padding: "0px 0px 0px 0px",
        margin: "0px 0px 0px 0px",
        height: "25px",
        transition: "box-shadow 0.1s ease-in-out, transform 0.03s ease-in-out",
        selectors: {
            ":active": {
                boxShadow: "0 8px 16px 0 rgba(47, 72, 88, 0.219)",
                transform: "translateY(1px)"
            },
            ":hover": {
                boxShadow: "0 8px 14px 0 rgba(47, 72, 88, 0.486), 0 10px 26px 0 rgba(47, 72, 88, 0.444)"
            }
        }
    }
};

export const analysisRemoveButStyles = {
    root: {
        color: "#8d4846",
        padding: "0px 0px 0px 0px",
        margin: "0px 0px 0px 0px",
        height: "28px",
        width: "28px",
        borderRadius: "5px"
    }
};

export const thStylesDetList1 = { padding: "8px", TextAlign: "left", borderBottom: "1px solid #ccc" }

export const thStylesDetList2 = { padding: "8px", TextAlign: "left", borderBottom: "1px solid #eee" }

export const tooltipStylesCompAdmin = {
    styles: {
        root: {
            borderRadius: "5px"
        },
        beak: {
            left: "20px !important",
            right: "auto !important"
        },
        beakCurtain: {
            borderRadius: "5px"
        },
        calloutMain: {
            borderRadius: "5px"
        }
    }
};

export const playButStylesSBS = {
    root: {
        left: "102px",
        margin: "5px 5px",
        borderRadius: "5px"
    }
};

export const pauseButStylesSBS = {
    root: {
        left: "102px",
        backgroundColor: "#ff75fd",
        margin: "5px 5px",
        borderRadius: "5px"
    }
};

export const iconButtonStylesTagInput = {
    root: {
        width: 15, // Set desired width
        height: 15, // Set desired height
        borderRadius: 3, // Set border radius (e.g., 5px)
        marginRight: 5 // Set margin between icon and label (e.g., 5px
    },
    icon: {
        fontSize: 16 // Set icon size (e.g., 16px)
    }
};

export const calloutStylesExportDocCallout = mergeStyleSets({
    container: {
        position: "relative",
        display: "inline-block",
        borderRadius: "7px"
    },
    triggerText: {
        cursor: "pointer"
    },
    callout: {
        backgroundColor: "#f8f8f8",
        border: "1px solid #ddd",

        borderRadius: "7px",

        boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
    }
});

export const detailsListTheme = createTheme({
    palette: {
        themePrimary: "#00b977",
        themeLighterAlt: "#00b029"
    },
    defaultFontStyle: {
        fontFamily: "Urbanist, Roboto",
    }
});

export const scrollablePaneStyles: Partial<IScrollablePaneStyles> = {
    root: {
        position: "relative",
        overflowY: "auto",
        height: "calc(100vh - 130px)"
    },
};

export const scrollablePaneShortStyles: Partial<IScrollablePaneStyles> = {
    root: {
        position: "relative",
        overflowY: "auto",
        height: "calc(100vh - 170px)"
    },
};

export const toggleStylesCompEdit = { root: { marginLeft: "0px" }, label: { fontSize: "14px", fontFamily: "Urbanist" } };
export const toggleStylesCompDynReEdit: Partial<IToggleStyles> = {
    root: { marginLeft: "0px" }, label: { fontSize: "14px", fontFamily: "Urbanist" },
    container: { marginTop: "6px" }
};

export const toggleStylesSendMail: Partial<IToggleStyles> = {
    root: { marginLeft: "0px" },
    label: { fontSize: "14px", fontFamily: "Urbanist" }
};
export const toggleStylesNewCampaignEnable: Partial<IToggleStyles> = {
    root: { marginLeft: "0px", height: "40px",  },
    label: { fontSize: "10px", fontFamily: "Raleway, Urbanist, Roboto", color: "#949694", fontWeight: 600, textTransform: "uppercase" },
    text: { fontSize: "12px", fontFamily: "Raleway, Urbanist, Roboto", color: "#3e7798", fontWeight: "600 !important", lineHeight: "20px" }
};
export const toggleStylesAutBaseExtractionSettings = { root: { marginLeft: "0px", marginBottom: "4px !important", marginTop: "4px !important" }, label: { fontSize: "14px", minWidth: "100%", fontFamily: "Urbanist" } };


export const toggleStylesAutBaseExtraction = { root: { marginLeft: "0px" }, label: { fontSize: "14px", minWidth: "100%", fontFamily: "Urbanist" } };

export const orderHeaderCustomStyles: Partial<IDetailsHeaderStyles> = {
    root: {

        padding: "0px !important",
        margin: "0px !important",
        font: "normal normal 13px/40px Raleway, Urbanist,Roboto !important",
        fontFamily: "Raleway, Urbanist, Roboto",

        cursor: "pointer",
        position: "sticky",
        top: 0,
        zIndex: 100,
        backgroundColor: "#fff",
        borderBottom: "1px solid #ddd"
    },
    check: {
        padding: "0px !important",
        margin: "0px !important",
        fontFamily: "Raleway, Urbanist, Roboto !important",
    },
};

export const stylesScrl: Partial<IScrollablePaneStyles> = {
    root: {inset: "left"},
    contentContainer: {
        inset: "0 !important",
        maxWidth: "100vdw",
        minWidth: "100%",
    }
}

export const controlInvStyles: Partial<any> = {
    styles: {
        root: {
            width: '100%',
            minWidth: 800,
            overflow: 'unset !important' ,
        },
        headerWrapper: {
            position: "sticky",
            top: 0,
            zIndex: 1
        } as IStyle,
        cells: {
            overflow: 'unset !important',
            padding: '0px !important',
        }

    },
};

export const spaceTitleStyles: Partial<IDocumentCardTitleStyles> = {
    root: {
        font: "normal normal 1000 18px/22px Urbanist, Roboto",
        color: "#485a73",
        textAlign: "left",
        marginLeft: "-20px",
        marginBottom: -18,
        height: "auto"
    }
}

export const docCardStyles: Partial<IDocumentCardStyles> = {
    root: {
        width: 300,
        marginBottom: 0,
        marginTop: 20,
        height: "100%",
        borderRadius: "10px",
        backgroundColor: "rgba(193, 200, 214,0.16)",
        padding: "0px 0px 0px 0px",
        position: "relative",
        border: "none",
        transition: "box-shadow 0.1s ease-in-out, transform 0.03s ease-in-out",
        selectors: {
            ":hover": {
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                border: "none"
            },
            ":hover:after": {
                border: "none"
            },
            ":active": {
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                transform: "translateY(4px)",
                border: "none",
                borderRadius: 10
            },
            ":active:after": {
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                transform: "translateY(2px)",
                border: "none",
                borderRadius: 10
            }
        }
    }
}

export const spaceCardExtraInfoStyles: any = {
    root: {
        display: "flex",
        textAlign: "left",
        paddingBottom: 5,
        font: "normal normal normal 12px/19px Urbanist, Roboto",
        color: "#9baebc",
        verticalAlign: "middle",
        alignContent: "center"
    }
}

export const spaceCardOptionTextStyles: any = {
    root: {
        position: "absolute",
        bottom: 10,
        right: 20,
        textAlign: "right",
        height: 25,
        paddingBottom: 0,
        font: "normal normal normal 16px/19px Urbanist, Roboto",
        color: "#97accf",
        width: "87%"
    }
}

export const spaceCardDescriptionStyles: any = {
    root: {
        textAlign: "left",
        paddingBottom: "30px",
        paddingRight: "8px",
        font: "normal normal normal 15px/17px Urbanist, Roboto",
        color: "#485a73",
        overflow: "hidden",
    }
}

export const spaceCardGlobeIconTextStyles: any = {
    root: {
        font: "normal normal normal 16px/19px Urbanist, Roboto",
        color: "#797C95",
        marginLeft: "10px"
    }
}

export const spaceCardPremiumTextStyles: any = {
    root: {
        font: "normal normal normal 16px/19px Urbanist, Roboto",
        color: "#797C95"
    }
}

export const spaceCardEmtpyStyles: any = {
    root: {
        textAlign: "left",
        paddingBottom: 5,
        font: "normal normal normal 12px/19px Urbanist, Roboto",
        color: "#797C95"
    }
}

export const invOvrvuHoverStyles: Partial<IHoverCardStyles> = {
    host: {
        padding: "0px",
        display:"flex",
        minWidth: "0px",
        maxWidth: "400px"
    }
};

export const groupStackDnb:  any = {
    expandedCardScroll: {
        overflowY: "scroll",
    },
    expandedCard: {
        height: "content",
    },
};

export const invItemListIsPercCheckboxStyle: Partial<ICheckboxStyles> = {
    text: {
        fontFamily: "Urbanist",
        fontSize: "10px",
        marginTop: "-3px",
        marginLeft: "-2px"
    },
    checkbox: {
        width: "14px",
        height: "14px",

    },
    label: {
        fontFamily: "Urbanist, Roboto",
        fontSize: "10px",
        width: "14px",
        height: "14px"
    },
    checkmark: {
        selectors: {
            ":hover": {
                border: "3px solid white"
            }
        }
    },
    root: {
        fontFamily: "Urbanist",
        selectors: {
            ":hover .ms-Checkbox-checkbox": {

            },
            ":hover .ms-Checkbox-checkmark": {

            },
            ".is-checked .ms-Checkbox-checkbox": {
                background: "#7e7e7e",
                border: "3px solid #7e7e7e"

            }
        }
    }
};


export const campaignTextFieldStyles: Partial<ITextFieldStyles> = {
    wrapper: {
        selectors: {
            label: {
                fontFamily: "Urbanist"
            }
        }
    },
    root: {
        borderRadius: "4px"
    },
    fieldGroup: {
        maxWidth: "800px",
        borderRadius: "4px",
        marginLeft: "4px",
        marginRight: "4px",
        marginTop: "4px",
        marginBottom: "4px",
        border: "1px solid #cdcdcd",
        selectors: {
            "::after": {
                borderRadius: "4px ",
                border: "1px solid #cdcdcd"
            },
            "::before": {
                borderRadius: "4px ",
                border: "1px solid #cdcdcd"
            },
            ":hover": {
                borderRadius: "4px ",
                border: "1px solid #cdcdcd"
            },
            ":focus": {
                borderRadius: "4px ",
                border: "1px solid #cdcdcd"
            },
            ":active": {
                borderRadius: "4px ",
                border: "1px solid #cdcdcd"
            },
            ":focus-within": {
                borderRadius: "4px ",
                border: "1px solid #cdcdcd"
            },
            ":focus-visible": {
                borderRadius: "4px ",
                border: "1px solid #cdcdcd"
            }
        }
    },
    subComponentStyles: {
        label: {
            root: {
                fontSize: "14px",
                fontFamily: "Urbanist"
            }
        }
    }
};

// teal-themed checkbox style for the row-selection column (matches toolbar accent)
export const selCheckboxStyles = {
    root: { padding: 0 },
    checkbox: {
        width: 16,
        height: 16,
        borderRadius: 3,
        borderColor: '#00c6af',
        selectors: {
            ':hover': { borderColor: '#00c6af' }
        }
    },
    checkmark: { color: '#ffffff' },
    label: { margin: 0 },
} as const;